import { isAdminFromToken } from "../../utils/jwt";

// Admin kullanıcı tipini tanımla
export interface Admin {
  uid: string;
  email: string;
  admin: boolean;
  firebase_token?: string; // YENİ ALAN: Backend model değişikliği
}

export interface AuthResponse {
  success: boolean;
  user: Admin;
  token?: string;
}

export const isCurrentUserAdmin = async (): Promise<boolean> => {
  try {
    // Token'dan admin bilgisini kontrol et
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.warn("❌ No auth token found");
      return false;
    }

    // JWT token'dan admin bilgisini decode et
    const isAdmin = isAdminFromToken(token);
    console.log("✅ Admin verification from token:", isAdmin);

    return isAdmin;
  } catch (error: any) {
    console.warn("❌ Admin verification failed:", error.message);
    console.error("Admin kontrol hatası:", error);
    return false;
  }
};

// Simple logout - sadece local token'ı temizle
export const logout = async (): Promise<void> => {
  try {
    localStorage.removeItem("authToken");
    console.log("✅ User logged out successfully");
  } catch (error) {
    console.warn("Logout error:", error);
    localStorage.removeItem("authToken");
  }
};
